import React, { useState, useRef, useEffect } from 'react'
import "./SelfFeedback.css"
import { QRCode, Rate } from 'antd'
import billIcon from '../../../Assets/Images/Logo.png';
import SelfOrderFooter from '../Navbar/SelfOrderFooter';
import { useSelector } from 'react-redux';
import { Dialog, IconButton, Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import CloseIcon from '@mui/icons-material/Close';
import PosReceiptTemplate from '../../../component/Modules/components/template/posReceipt/PosReceiptTemplate';
import { useReactToPrint } from '../../../component/Shared/print/useHtml2PdfPrint';
import { submitFeedbackSelfOrderAPI } from '../../API/selfOrderAPIS';
import { getSelfReceiptSettings, shareSelfReceipt } from '../../selfReceiptShareUtils';
const SelfFeedback = ({newOrderClick}) => {

    const { receiptData } = useSelector((state) => state.viewOrdersBillingSlice);
    const { selfCustomer } = useSelector((state) => state.selfOrderEssentialsSlice);
    const userInfo = useSelector((state) => state.loginResponseSlice.value);

    const domainAddress = `${window.location.protocol}//${window.location.host}/posReaderPreview?path=admin/viewqrcodedata&db=${encodeURIComponent(receiptData?.db)}&vendororcusid=${encodeURIComponent(receiptData?.cusId)}&type=${encodeURIComponent("POS")}&orderId=${encodeURIComponent(receiptData?._id)}`;

    const [viewReceipt,setViewReceipt]=useState(false)
    const [manualShare,setManualShare]=useState(null)
    const desc = ['terrible', 'bad', 'normal', 'good', 'wonderful'];
    const [value,setValue]=useState(5)
    const [feedBack,setFeedback]=useState("")

    const receiptRef = useRef(null)

    // resolve customer contact (self-order customer, then receipt payload)
    const customerMobile = selfCustomer?.mobileNo || receiptData?.customerName?.mobileNo || receiptData?.mobileNo || ''
    const customerEmail = selfCustomer?.email || receiptData?.customerName?.email || receiptData?.email || ''
    const branchId = userInfo?.branchPk || localStorage.getItem('branchId') || ''
    const shareMessage = `Receipt for order ${receiptData?.name || ''}`.trim()

    const handlePrint = useReactToPrint({ content: () => receiptRef.current })

    // auto-print when the receipt opens, if enabled in the 3-bar menu settings
    useEffect(() => {
        if (viewReceipt && getSelfReceiptSettings().autoPrint) {
            const t = setTimeout(() => { handlePrint(); }, 1200)
            return () => clearTimeout(t)
        }
    }, [viewReceipt])

    const handleShare = async () => {
        const result = await shareSelfReceipt({
            node: receiptRef.current,
            fileName: `receipt-${receiptData?.name || 'order'}.pdf`,
            message: shareMessage,
            shareUrl: domainAddress,
            customerMobile,
            customerEmail,
            branchId,
        })
        if (result?.method === 'manual') {
            setManualShare(result.links)
        }
    }

    const submitRatingClick=()=>{
        let payload={
            orderId: receiptData?._id,
            custRating: value,
            custComment: feedBack
        }
        submitFeedbackSelfOrderAPI(payload,newOrderClick)
    }
    return (
        <div className='self-feedback-ctn self-order-middle-container'>
            <div className='feedback'>
                <div className='self-feedback-first-main'>
                    <div className='self-feedback-content '>
                        <h1>Your Order No:</h1>
                        <h3> {receiptData?.name}</h3>
                    </div>
                </div>
                <div className='self-feedback-secound-main'>
                    <div className='self-feedback-content stardiv'>
                        <h1> Give us feedback</h1>
                        <div className="star-rating">
                            <Rate 
                                tooltips={desc} 
                                allowHalf
                                style={{ fontSize: '32px' }}
                                onChange={setValue} 
                                value={value} 
                            />
                        </div>
                            <div className='feedback-textarea-div'>
                                <textarea
                                    value={feedBack}
                                    onChange={(e)=>setFeedback(e.target.value)}
                                    className="feedback-textarea"
                                    placeholder="Type Something....."
                                    rows="5"
                                ></textarea>
                            </div>
                    </div>
                    <div className='self-feedback-content QRcodeDiv'>
                        <QRCode 
                        value={domainAddress}
                        className='qrcode'
                        icon={billIcon}
                        size={150}
                        imageSettings={{
                          src: "/logo.png", // Your logo path
                          x: null, // Automatically centers the logo
                          y: null,
                          height: 40,
                          width: 40,
                          excavate: true, // Ensures QR code parts aren't covered
                        }}
                        />
                        <h1>SCAN QR CODE FOR RECEIPT</h1>
                        <h1>OR</h1>
                        <button className='self-btn' onClick={()=> setViewReceipt(true)}>View Receipt</button>
                    </div> 
                </div>
               


            </div>
            <SelfOrderFooter redBtnText={"SUBMIT"} blackBtnText={"NEW ORDER"} blackBtnOnclick={newOrderClick} redBtnOnClick={submitRatingClick}/>

            <Dialog open={viewReceipt} onClose={()=>setViewReceipt(false)} maxWidth="xs">
                <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '4px 8px 0' }}>
                    <IconButton size="small" onClick={()=>setViewReceipt(false)}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </div>
                <div ref={receiptRef}>
                    <PosReceiptTemplate templateOverride={11} />
                </div>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', padding: '12px' }}>
                    <Button variant="outlined" startIcon={<PrintIcon />} onClick={handlePrint}>
                        Print
                    </Button>
                    <Button variant="contained" color="success" startIcon={<ShareIcon />} onClick={handleShare}>
                        Share
                    </Button>
                </div>
            </Dialog>

            {/* manual share fallback (when native share / auto-send unavailable) */}
            <Dialog open={Boolean(manualShare)} onClose={()=>setManualShare(null)}>
                <div style={{ padding: '16px 20px', minWidth: '240px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <h3 style={{ margin: 0 }}>Share receipt</h3>
                        <IconButton size="small" onClick={()=>setManualShare(null)}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <Button variant="outlined" color="success" startIcon={<WhatsAppIcon />}
                            disabled={!customerMobile}
                            onClick={()=>{ window.open(manualShare.whatsapp, '_blank'); setManualShare(null) }}>
                            WhatsApp
                        </Button>
                        <Button variant="outlined" startIcon={<SmsIcon />}
                            disabled={!customerMobile}
                            onClick={()=>{ window.location.href = manualShare.sms; setManualShare(null) }}>
                            SMS
                        </Button>
                        <Button variant="outlined" color="error" startIcon={<EmailIcon />}
                            onClick={()=>{ window.location.href = manualShare.email; setManualShare(null) }}>
                            Email
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default SelfFeedback